import React, { useContext } from 'react';
import { StyleContext } from '@theme/AppStyles';

const LinkOutIcon = ({size = 24}:{size?: number}) => {
  const [style] = useContext(StyleContext);
  const color = style.palette.textPrimary;
  const colorHighlight = style.palette.accentPrimary;
  return (<svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill={color} d="M21,13v5.5c0,1.2-1,2.3-2.3,2.3H5.3c-1.2,0-2.3-1-2.3-2.3V5.5c0-1.2,1-2.3,2.3-2.3h5.7c.6,0,1-.4,1-1h0c0-.6-.4-1-1-1h-5.7C2.9,1.2,1,3.1,1,5.5v13.1c0,2.4,1.9,4.3,4.3,4.3h13.5c2.4,0,4.3-1.9,4.3-4.3v-5.5c0-.6-.4-1-1-1h0c-.6,0-1,.4-1,1Z" />
    <path fill={colorHighlight} d="M23.1,2.2c0-.6-.5-1-1-1h-6c-.6,0-1,.5-1,1s.5,1,1,1h3.6l-6.9,6.9c-.4.4-.4,1,0,1.4s.5.3.7.3.5,0,.7-.3l6.9-6.9v3.5c0,.6.4,1,1,1s1-.4,1-1V2.2s0,0,0,0Z" />
  </svg>)
}

export default LinkOutIcon;